<template>
    <status-badge
                  v-if="showBadge"
                  :icon="scoreIcon"
                  :variant="scoreVariant"
                  :title="scoreTitle">
        <template v-slot:default>
            <slot :score="formattedScore" :title="scoreTitle" :isValid="isScoreValid">
                <span v-if="showScore">{{ formattedScore }}</span>
                <span v-if="showText">{{ scoreTitle }}</span>
            </slot>
        </template>
    </status-badge>
</template>

<script>
import StatusBadge from './StatusBadge.vue';

export default {
    name: 'ScoreDisplay',
    components: {
        StatusBadge
    },
    props: {
        score: {
            type: Number,
            required: false,
            default: null,
            validator(value) {
                // Allow null/undefined for missing scores, or valid numbers
                return value === null || value === undefined || (typeof value === 'number' && !isNaN(value))
            }
        },
        highConfidenceThreshold: {
            type: Number,
            default: 0.75
        },
        mediumConfidenceMin: {
            type: Number,
            default: 0.6
        },
        mediumConfidenceMax: {
            type: Number,
            default: 0.75
        },
        highConfidenceText: {
            type: String,
            default: 'High confidence'
        },
        mediumConfidenceText: {
            type: String,
            default: 'Medium confidence'
        },
        lowConfidenceText: {
            type: String,
            default: 'Low confidence'
        },
        showScore: {
            type: Boolean,
            default: true
        },
        showText: {
            type: Boolean,
            default: true
        },
        scoreDecimals: {
            type: Number,
            default: 4
        },
        successVisible: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        isScoreValid() {
            return this.score !== null && this.score !== undefined && typeof this.score === 'number'
        },
        formattedScore() {
            if (!this.isScoreValid) {
                return 'N/A'
            }
            return this.score.toFixed(this.scoreDecimals)
        },
        scoreIcon() {
            if (!this.isScoreValid) {
                return 'b-question-circle-fill'
            }
            if (this.score > this.highConfidenceThreshold) {
                return 'b-check-circle-fill'
            } else if (this.score >= this.mediumConfidenceMin && this.score <= this.mediumConfidenceMax) {
                return 'b-exclamation-triangle-fill'
            } else {
                return 'b-x-circle-fill'
            }
        },
        scoreVariant() {
            if (!this.isScoreValid) {
                return 'info'
            }
            if (this.score > this.highConfidenceThreshold) {
                return 'success'
            } else if (this.score >= this.mediumConfidenceMin && this.score <= this.mediumConfidenceMax) {
                return 'warning'
            } else {
                return 'danger'
            }
        },
        scoreTitle() {
            if (!this.isScoreValid) {
                return this.$t('components.order.scoredisplay.score_unavailable')
            }
            if (this.score > this.highConfidenceThreshold) {
                return this.highConfidenceText
            } else if (this.score >= this.mediumConfidenceMin && this.score <= this.mediumConfidenceMax) {
                return this.mediumConfidenceText
            } else {
                return this.lowConfidenceText
            }
        },
        showBadge() {
            if (!this.isScoreValid) {
                return true // Show badge for invalid/unavailable scores
            }
            return this.successVisible || this.score <= this.highConfidenceThreshold
        }
    }
}
</script>

<style lang="scss" scoped></style>
